// Model imports
const {
  COLLECTION_EDITED,
  COLLECTION_FOLLOWING_CHANGE_PENDING,
  COLLECTION_FOLLOWING_CHANGE
} = require('./actions')
const CollectionModelRecord = require('./record')

/* eslint-disable complexity */
function collectionReducer(state, { type, payload }) {
  // Sanity check
  if (!payload || !(state instanceof CollectionModelRecord)) {
    return state
  }
  // Ignore actions that don't refer to this collection
  if (payload.collectionId !== state.id) {
    return state
  }
  switch (type) {
    case COLLECTION_FOLLOWING_CHANGE: {
      const countDiff = followerCountDiff(payload)
      return state.merge({
        'follower_count': state['follower_count'] + countDiff,
        isFollowing: payload.isFollowing
      })
    }
    case COLLECTION_EDITED:
      return state.merge(payload.collection)
    default:
      return state
  }
}
/* eslint-enable complexity */

module.exports = collectionReducer

function followerCountDiff({ isFollowing }) {
  if (isFollowing === COLLECTION_FOLLOWING_CHANGE_PENDING) {
    return 0
  }
  return isFollowing ? +1 : -1
}
